// extracted by mini-css-extract-plugin
export default {"PhotoCapture":"PhotoCapture_PhotoCapture__xZ2ke"};